<template>
  <div id="app">
    <keep-alive>
      <the-loader v-if="isLoading"/>
    </keep-alive>
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  computed: {
    isLoading() {
      return this.$store.state.loader;
    },
  },
  components: {
    TheLoader: () => import('@/modules/common/components/TheLoader.vue'),
  },
};
</script>
